import { registerService } from './lib';

export type OtcCoinBalance = {
  coin: string;
  kucoin_balance: string;
  iqx_balance: string;
  total_balance: string;
  desired_balance: string;
  difference: string;
};

export type OtcTransferStatus =
  | 'pending'
  | 'inner_transferred'
  | 'inner_transfer_pending'
  | 'processing'
  | 'success'
  | 'failed';

export type OtcTransferDirection = 'kucoin_to_iqx' | 'iqx_to_kucoin';

export type OtcTransfer = {
  id: number;
  coin: string;
  direction: OtcTransferDirection;
  amount: string;
  network: string;
  status: OtcTransferStatus;
  withdrawal_id: string | null;
  tx_id: string | null;
  fee: string | null;
  address: string | null;
  memo: string | null;
  error_message: string | null;
  created_at: string;
  updated_at: string;
};

export type OtcCreateTransferResponse =
  | { transfer: OtcTransfer }
  | { log_only: true; message: string };

export type ExchangeBalance = {
  coin: string;
  balance: string;
  balance_usdt?: string;
  balance_iqd?: string;
  percentage_of_total?: number;
};

export type ExchangeAccountType = 'trade' | 'main';

export type ExchangeRate = {
  city: string;
  cityKey: string;
  bid: number | null;
  offer: number | null;
  updatedAt: string;
};

export type ExchangeRates = {
  success: boolean;
  data: {
    channel: string;
    currency: string;
    rates: ExchangeRate[];
    lastUpdate: string;
  };
};

declare module './lib' {
  interface ServiceRegistry {
    'otc-settle': ServiceEndpoints<{
      'get:exchange-balance/': {
        params: { account: ExchangeAccountType };
        response: {
          balances: ExchangeBalance[];
        };
      };
      'get:coin-balances/': {
        response: { coins: OtcCoinBalance[] };
      };
      'get:networks/': {
        response: { networks: string[] };
      };
      'get:transfers/': {
        params: {
          status?: string;
          coin?: string;
          direction?: OtcTransferDirection;
        };
        response: { transfers: OtcTransfer[] };
      };
      'post:transfers/': {
        params: {
          coin: string;
          amount: string;
          network: string;
          direction: OtcTransferDirection;
        };
        response: OtcCreateTransferResponse;
      };
    }>;
    'p2p-maker': ServiceEndpoints<{
      'get:exchange-balance/': {
        params: { account: ExchangeAccountType };
        response: {
          balances: ExchangeBalance[];
        };
      };
    }>;
    ibot: ServiceEndpoints<{
      'get:exchange-rates': {
        response: ExchangeRates;
      };
    }>;
  }
}

registerService('otc-settle', '/proxy/otc-settle');
registerService('p2p-maker', '/proxy/p2p-maker');
registerService('ibot', 'https://ibot.iqx.io/api');
